<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="outletform" id="outletform" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-btn color="grey" dark class="mb-2 mr-2" @click="backToOutlet()" small>
                        <v-icon small>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                    <v-dialog v-model="dialogProductWarning" max-width="500px">
                        <v-card>
                            <v-card-title class="body-1 text-center">Produk yang Anda pilih sudah ada.</v-card-title>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="dialogProductWarning = false">OK</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
                <div class="mt-3" v-if="isLoading">
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                        <v-col cols="6">
                            <v-skeleton-loader type="text" height="50" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="6">
                            <v-skeleton-loader type="table-thead" />
                            <v-skeleton-loader type="table-tbody" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="12">
                            <v-skeleton-loader type="table-thead" />
                            <v-skeleton-loader type="table-tbody" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="12">
                            <v-skeleton-loader type="table-thead" />
                            <v-skeleton-loader type="table-tbody" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="12">
                            <v-skeleton-loader type="table-thead" />
                            <v-skeleton-loader type="table-tbody" />
                        </v-col>
                    </v-row>
                    
                </div>
                <div class="mt-3" v-else>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="6">
                            <span class="pb-4">Outlet Code</span>
                            <v-text-field maxlength="10" v-model="outlet.code" outlined rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex > -1" :rules="reqRule" />
                        </v-col>
                        <v-col cols="6">
                            <span>Opening</span>
                            <v-text-field type="number" v-model="outlet.opening" outlined rounded dense hide-details="auto" @keydown.space.prevent :rules="reqRule" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="6">
                            <span>Outlet Name</span>
                            <v-text-field v-model="outlet.name" outlined rounded dense hide-details="auto" :rules="reqRule" />
                        </v-col>
                        <v-col cols="6">
                            <span>Remaining</span>
                            <v-text-field v-model="outlet.remaining" type="number" readonly outlined rounded dense hide-details="auto" @keydown.space.prevent />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form" align="center">
                        <v-col cols="6">
                            <span>Category</span>
                            <v-select outlined dense hide-details="auto" :items="categories" item-text="name" item-value="code" v-model="outlet.outlet_category_code" :rules="reqRule" @change="chooseCategory" ></v-select>
                        </v-col>
                        <v-col cols="6">
                            <span>Call Center</span>
                            <v-select outlined dense hide-details="auto" :items="call_centers" item-text="name" item-value="code" v-model="outlet.call_center_code" :rules="reqRule"></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form">
                        <v-col cols="6">
                            <div>
                                <span>Address</span>
                                <v-textarea outlined v-model="outlet.address" dense rows="2" />
                            </div>  
                            <div>
                                <span>Email</span>
                                <v-text-field v-model="outlet.email" outlined rounded dense hide-details="auto" />
                            </div> 
                            <div>
                                <span>Notes</span>
                                <v-textarea outlined v-model="outlet.notes" dense rows="2" />
                            </div>  
                        </v-col>
                        <v-col cols="6">
                            <div>
                                <span>Sales Schedule</span>
                                <v-select v-model="outlet.delivery_schedules" :items="delivery_schedules" item-value="key" item-text="value" multiple outlined dense hide-details="auto" @change="changeDeliverySchedule"></v-select>
                            </div>
                            <div class="mt-2">
                                <span>Delivery</span>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th v-for="(delivery, idx) in outlet.delivery_schedules" :key="idx">{{ delivery_schedules[delivery -1].value }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-for="(delivery, idx) in outlet.delivery_schedules" :key="idx">
                                                    <v-text-field v-model.number="outlet.delivery_schedules2[idx]"
                                                        type="number" outlined rounded dense hide-details="auto" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                            <div class="mt-2">
                                <span>Arrival</span>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th v-for="(delivery, idx) in outlet.delivery_schedules" :key="idx">{{ delivery_schedules[delivery -1].value }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-for="(delivery, idx) in outlet.delivery_schedules" :key="idx">
                                                    <v-text-field v-model.number="outlet.arrive_schedules[idx]"
                                                        type="number" outlined rounded dense hide-details="auto" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>                            
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form">
                        <v-col cols="6">
                            <span>Operational Team</span>
                            <v-select outlined dense hide-details="auto" :items="users" item-text="fullname" item-value="username" v-model="outlet.operational_team_code" :rules="reqRule"></v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-switch v-model="outlet.is_inner_city" :label="labelLuarKota" @change="changeInnerCity" />
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form">
                        <v-col cols="6">
                            <span>Iseller Outlet Code</span>
                            <v-text-field v-model="outlet.iseller_outlet_code" outlined rounded dense hide-details="auto" />
                        </v-col>
                        <v-col cols="6">
                            <span>Iseller Outlet ID</span>
                            <v-text-field v-model="outlet.iseller_outlet_id" outlined rounded dense hide-details="auto" @keydown.space.prevent />
                        </v-col>
                    </v-row>
                    <!-- <v-row class="mx-5 py-0 compact-form">
                        <v-col cols="3">
                            <v-card v-if="!outlet.is_inner_city">
                                <v-card-title>Status Botol</v-card-title>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <tbody>
                                            <tr v-for="(statusBotol, isb) in outlet.status_botol" :key="isb">
                                                <th>{{ delivery_schedules[isb].value }}</th>
                                                <td>
                                                    <v-text-field type="number" v-model="outlet.status_botol[isb]" dense outlined :rules="[numberRule]" min="0" class="compact-form centered-input" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row> -->
                    <v-row class="mx-5 py-0 compact-form">
                        <v-col cols="12">
                            <v-card outlined>
                                <v-card-title class="text-h6 py-2">Coordinator</v-card-title>
                                <v-simple-table fixed-header dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th v-show="isDeliverySchedule(1)">Minggu</th>
                                                <th v-show="isDeliverySchedule(2)">Senin</th>
                                                <th v-show="isDeliverySchedule(3)">Selasa</th>
                                                <th v-show="isDeliverySchedule(4)">Rabu</th>
                                                <th v-show="isDeliverySchedule(5)">Kamis</th>
                                                <th v-show="isDeliverySchedule(6)">Jumat</th>
                                                <th v-show="isDeliverySchedule(7)">Sabtu</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-show="isDeliverySchedule(1)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_sun" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                <td v-show="isDeliverySchedule(2)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_mon" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                <td v-show="isDeliverySchedule(3)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_tue" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                <td v-show="isDeliverySchedule(4)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_wed" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                <td v-show="isDeliverySchedule(5)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_thu" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                <td v-show="isDeliverySchedule(6)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_fri" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                <td v-show="isDeliverySchedule(7)">
                                                    <v-layout>
                                                        <v-autocomplete :items="coordinators" item-text="name" item-value="code" outlined dense hide-details class="compact-form" v-model="outlet.coordinator_sat" clearable>
                                                            <template slot="selection" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>                            
                                                            <template slot="item" slot-scope="data">
                                                            {{ data.item.name }}
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-layout>
                                                </td>
                                                
                                            </tr>
                                            <tr>
                                                <td v-show="isDeliverySchedule(1)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_sun" clearable>
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td v-show="isDeliverySchedule(2)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_mon" clearable>
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td v-show="isDeliverySchedule(3)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_tue" clearable >
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td v-show="isDeliverySchedule(4)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_wed" clearable>
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td v-show="isDeliverySchedule(5)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_thu" clearable>
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td v-show="isDeliverySchedule(6)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_fri" clearable>
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                                <td v-show="isDeliverySchedule(7)">
                                                    <span>Line</span>
                                                    <v-select outlined dense hide-details="auto" class="compact-form" :items="lines" item-text="description" item-value="code" v-model="outlet.line_sat" clearable>
                                                        <template #item="{item, props}">
                                                            <div v-if="item">
                                                                <v-list-item v-bind="props" class="d-flex flex-column align-start">
                                                                    <span class="font-weight-bold">{{ item.description }}</span>
                                                                    <small class="grey--text">{{ item.misc_field }}</small>
                                                                </v-list-item>
                                                            </div>
                                                        </template>
                                                        <template #selection="{item}">
                                                            {{ item.description }} : {{ item.misc_field }}
                                                        </template>
                                                    </v-select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 py-0 compact-form">
                        <v-col>
                            <v-card outlined>
                                <v-simple-table class="spreadsheet-table flex-table" fixed-header>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="header-cell">Hari</th>
                                                <th class="header-cell text-center">Min Stock</th>
                                                <th class="header-cell text-center">Max Stock</th>
                                                <th class="header-cell text-center">Min Stock 250</th>
                                                <th class="header-cell text-center">Max Stock 250</th>
                                                <th class="header-cell text-center" v-for="defaultTime in filteredDefaultTimes" :key="defaultTime.id">
                                                    {{ defaultTime.text }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idt) in weekdaysPercents" :key="idt">
                                                <td class="header-cell">{{ defaultDays[idt].value }}</td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field class="" v-model="outlet.weekdays_hours_percent[idt].min_stock" type="number"  solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field class="" v-model="outlet.weekdays_hours_percent[idt].max_stock" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field class="" v-model="outlet.weekdays_hours_percent[idt].min_stock2" type="number"  solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </td>
                                                <td class="spreadsheet-cell">
                                                    <v-text-field class="" v-model="outlet.weekdays_hours_percent[idt].max_stock2" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                </td>
                                                <td class="text-center spreadsheet-cell" v-for="(item, idx) in item.times" :key="idx" v-show="idx >= indexTimeStart && idx <= indexTimeEnd" >
                                                    <v-text-field v-model="outlet.weekdays_hours_percent[idt].times[idx]" type="number" suffix="%"  solo hide-details :rules="[numberRule]" min="0" class="text-center" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-start py-3 header-cell" :colspan="25">
                                                    <span style="color: red; font-weight: bold;">
                                                        * Jika toko tutup, Min Stock dan Max Stock diisi 0 pada hari tersebut.
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-start py-3 header-cell" :colspan="25">
                                                    <v-btn color="primary" depressed @click="resetToDefault">
                                                        Reset To Default
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-card outlined class="mx-5 compact-form">
                        <v-card-title class="text-h6 py-2">Expired</v-card-title>
                        <v-simple-table fixed-header dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Minggu</th>
                                        <th>Senin</th>
                                        <th>Selasa</th>
                                        <th>Rabu</th>
                                        <th>Kamis</th>
                                        <th>Jumat</th>
                                        <th>Sabtu</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="width:90px">Exp</td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_sun" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_mon" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_tue" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_wed" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_thu" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_fri" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                        <td><v-text-field class="compact-form centered-input" style="width:100px" v-model="outlet.expired_sat" type="number" dense outlined hide-details @wheel="$event.target.blur()" /></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card outlined class="mx-5 compact-form">
                        <v-card-title class="text-h6 py-2">Default PPIC</v-card-title>
                        <v-row class="pa-3 pt-0 mt-0 compact-form">
                            <v-col cols="6" md="3" sm="6">
                                <span>Choose Variant Bottle / Volume</span>
                                <v-select outlined dense hide-details="auto" :items="filteredBotols" item-value="code" item-text="description" v-model="filterBotol" @change="chooseBotol">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-simple-table class="spreadsheet-table pt-5 flex-table" fixed-header id="productTbl" height="440px">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="header-cell" colspan="2"></th>
                                        <th class="header-cell text-center">Minggu</th>
                                        <th class="header-cell text-center">Senin</th>
                                        <th class="header-cell text-center">Selasa</th>
                                        <th class="header-cell text-center">Rabu</th>
                                        <th class="header-cell text-center">Kamis</th>
                                        <th class="header-cell text-center">Jumat</th>
                                        <th class="header-cell text-center">Sabtu</th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell" colspan="2"></th>
                                        <th v-for="(day, index) in ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']"
                                            :key="index"
                                            class="header-cell text-center menu-dropdown">
                                        <v-select
                                            :items="menuOptions"
                                            item-value="code"
                                            item-text="menu_name"
                                            label="Pilih Menu"
                                            v-model="selectedMenuValues[index]"
                                            dense
                                            outlined
                                            hide-details
                                            @change="(value) => handleMenuChange(value, index)"
                                        />
                                        </th>

                                    </tr>
                                    <tr>
                                        <th class="header-cell text-center" colspan="2">Target Sales</th>
                                        <th class="spreadsheet-cell" v-for="(item, idt) in filteredOutletTargets.days" :key="idt">
                                            <v-text-field v-model="filteredOutletTargets.days[idt]" type="number" min="0" :rules="[numberRule]" solo hide-details @wheel="$event.target.blur()" />
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell text-center">Kode</th>
                                        <th class="header-cell text-center">Produk</th>
                                        <th class="header-cell text-center">Minggu (%)</th>
                                        <th class="header-cell text-center">Senin (%)</th>
                                        <th class="header-cell text-center">Selasa (%)</th>
                                        <th class="header-cell text-center">Rabu (%)</th>
                                        <th class="header-cell text-center">Kamis (%)</th>
                                        <th class="header-cell text-center">Jumat (%)</th>
                                        <th class="header-cell text-center">Sabtu (%)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(sales_target, sidx) in filteredSalesTargets" :key="sidx">
                                        <td class="header-cell text-no-wrap">{{ sidx + 1 }}.  {{ sales_target.code }}</td>
                                        <td class="header-cell text-no-wrap">{{ sales_target.name }}</td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_sun" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_mon" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_tue" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_wed" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_thu" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_fri" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                        <td class="spreadsheet-cell"><v-text-field v-model="sales_target.target_sat" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" /></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th class="header-cell"></th>
                                        <th class="header-cell"></th>
                                        <th class="header-cell text-center">{{ totalSalesTargetSun }}</th>
                                        <th class="header-cell text-center">{{ totalSalesTargetMon }}</th>
                                        <th class="header-cell text-center">{{ totalSalesTargetTue }}</th>
                                        <th class="header-cell text-center">{{ totalSalesTargetWed }}</th>
                                        <th class="header-cell text-center">{{ totalSalesTargetThu }}</th>
                                        <th class="header-cell text-center">{{ totalSalesTargetFri }}</th>
                                        <th class="header-cell text-center">{{ totalSalesTargetSat }}</th>
                                    </tr>
                                </tfoot>
                            </template>
                        </v-simple-table>
                        <v-row class="pa-3 py-4 px-4">
                            <v-col>
                                <v-btn color="primary" depressed @click="resetToDefaultPPIC">
                                    Reset To Default
                                </v-btn>
                            </v-col>
                        </v-row>
                        
                    </v-card>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn depressed color="primary" @click="saveOutlet" v-if="editedIndex === -1">
                        Submit
                    </v-btn>
                    <v-btn depressed color="primary" @click="updateOutlet" v-if="editedIndex > -1">
                        Update
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-snackbar top v-model="saved" color="green">Data berhasil tersimpan!</v-snackbar>
        <v-snackbar top v-model="saveError" color="red accent-2">Data gagal tersimpan! Mohon pastikan data yang akan disimpan sudah sesuai.</v-snackbar>
        <v-overlay :value="onProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="dialogResetToDefault" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">Konfirmasi</v-card-title>
                <v-card-text>Apakah Anda yakin ingin mereset data ke pengaturan awal ?</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="grey" text @click="closeReset">Cancel</v-btn>
                    <v-btn color="blue" text @click="resetConfirm">Reset To Default</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogResetToDefaultPPIC" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">Konfirmasi</v-card-title>
                <v-card-text>Apakah Anda yakin ingin mereset data ke pengaturan awal ?</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="grey" text @click="closeResetPPIC">Cancel</v-btn>
                    <v-btn color="blue" text @click="resetConfirmPPIC">Reset To Default</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogResetToDefaultPPIC: false,
            dialogResetToDefault: false,
            isLoading: true,
            dialogProductWarning: false,
            reqRule: [v => !!v || 'Must be filled'],
            numberRule: val => {
                if (val < 0) return 'Cannot be less than 0'
                return true
            },
            valid: true,
            saved: false,
            saveError: false,
            categories: null,
            call_centers: null,
            operational_teams: null,
            delivery_schedules: [
                { key: 1, value: 'Minggu' },
                { key: 2, value: 'Senin' },
                { key: 3, value: 'Selasa' },
                { key: 4, value: 'Rabu' },
                { key: 5, value: 'Kamis' },
                { key: 6, value: 'Jumat' },
                { key: 7, value: 'Sabtu' },
            ],
            users: [],
            menuOptions: [],
            selectedMenuValues: Array(7).fill(null),
            outlet: {
                code: '',
                name: '',
                outlet_category_code: '',
                address: '',
                email: '',
                notes: '',
                call_center_code: '',
                delivery_schedules: [],
                delivery_schedules2: [],
                arrive_schedules: [],
                operational_team_code: '',
                opening: '',
                remaining: '',
                min_stock_closing: '',
                max_stock_in: '',
                volume: '',
                showcase_capacity: '',
                has_short_showcase: false,
                line_code: '',
                coordinator_mon: 0,
                coordinator_tue: 0,
                coordinator_wed: 0,
                coordinator_thu: 0,
                coordinator_fri: 0,
                coordinator_sat: 0,
                coordinator_sun: 0,
                expired_mon: 0,
                expired_tue: 0,
                expired_wed: 0,
                expired_thu: 0,
                expired_fri: 0,
                expired_sat: 0,
                expired_sun: 0,
                sales_targets: [],
                weekdays_hours_percent: [],
                botols: [],
                line_mon: '',
                line_tue: '',
                line_wed: '',
                line_thu: '',
                line_fri: '',
                line_sat: '',
                line_sun: '',
                targets: [],
                menus: [],
                iseller_outlet_code: '',
                iseller_outlet_id: '',
                status_botol: [
                    { "0": 0 },
                    { "1": 0 },
                    { "2": 0 },
                    { "3": 0 },
                    { "4": 0 },
                    { "5": 0 },
                    { "6": 0 },
                ],
                is_inner_city: true,
            },
            onProgress: false,
            editedIndex: -1,
            filterBotol: '',
            coordinators: [],
            products: [],
            defaultTimes: [],
            indexTimeStart: 0,
            indexTimeEnd: 23,
            selectedBotol: [],
            botols: [],
            filteredBotols: [],
        }
    },
    computed: {
        labelLuarKota() {
            return this.outlet.is_inner_city ? 'Dalam Kota' : 'Luar Kota';
        },
        formTitle() {
            return this.editedIndex === -1 ? 'Add Outlet' : 'Edit Outlet'
        },
        lines() {
            let dataMiscCodes = this.$store.state.misccode.objs
            return dataMiscCodes.filter((i => i.type == 'Vehicle'))
        },
        filteredProducts() {
            return this.products.filter((p => p.size == this.filterBotol))
        },
        filteredSalesTargets() {
            return this.outlet.sales_targets.filter(i => i.size == this.filterBotol)
                .sort((a, b) => a.sort_no - b.sort_no);
        },
        totalSalesTargetMon() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_mon), 0)
        },
        totalSalesTargetTue() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_tue), 0)
        },
        totalSalesTargetWed() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_wed), 0)
        },
        totalSalesTargetThu() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_thu), 0)
        },
        totalSalesTargetFri() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_fri), 0)
        },
        totalSalesTargetSat() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_sat), 0)
        },
        totalSalesTargetSun() {
            return this.filteredSalesTargets.reduce((total, item) => total + Number(item.target_sun), 0)
        },
        isDeliverySchedule() {
            return (num) => {
                return this.outlet.delivery_schedules.includes(num);
            }
        },
        filteredDefaultTimes() {
            return this.defaultTimes.filter((item, index) => {
                return index >= this.indexTimeStart && index <= this.indexTimeEnd 
            })
        },
        filteredOutletTargets() {
            const filtered = this.outlet.targets.filter(item =>  item.size === this.filterBotol);

            if (filtered.length > 0) {
                return filtered[0];
            } else {
                const currentCategory = this.categories.find((category) => category.code === this.outlet.outlet_category_code);
                if (currentCategory) {
                    const selectedTarget = currentCategory.targets.find((target) => target.size === this.filterBotol);
                    return selectedTarget;
                } else {
                    return {
                        days: [0,0,0,0,0,0,0],
                        size: `${this.filterBotol}`
                    }
                }
            }
        },
        defaultDays() {
            return this.$store.state.outlet.default_days;
        },
        disabledResetToDefaultCategory() {
            return this.outlet.outlet_category_code != '' ? false : true;
        },
        weekdaysPercents() {
            return this.outlet.weekdays_hours_percent.map(item => ({
                ...item,
                min_stock: parseInt(item.min_stock) || 0,
                max_stock: parseInt(item.max_stock) || 0,
                min_stock2: parseInt(item.min_stock2) || 0,
                max_stock2: parseInt(item.max_stock2) || 0,
                times: item.times.map(time => parseInt(time) || 0)
            }));
        },
    },
    watch: {
        'outlet.outlet_category_code': function (newValue) {
            const selectedCategory = this.categories.find(row => row.code === newValue);
            this.indexTimeStart = this.defaultTimes.findIndex(item => item.text == selectedCategory.operational_hour_start)
            this.indexTimeEnd = this.defaultTimes.findIndex(item => item.text == selectedCategory.operational_hour_end)
        },
        dialogResetToDefault (val) {
            val || this.closeReset()
        },
    },
    async created() {
        this.getBotols()
        this.categories = (await this.$store.dispatch('outletcategory/getObjs')).data.data
        this.call_centers = (await this.$store.dispatch('callcenter/getObjs')).data.data
        this.operational_teams = (await this.$store.dispatch('operationalteam/getObjs')).data.data
        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data
        this.users = (await this.$store.dispatch('getObjs', {apidomain: 'users', parameter: ''})).data.data
        this.users = this.users.filter(user => user.group == 'OP')

        this.generateDefaultTime()
        this.getDataProducts()
        this.filterBotols()
        this.generateDefaultTargets()
        this.generateDefaultMenus();

        if (this.editedIndex === -1) {
            this.isLoading = false
        }

        const outlet_code = this.$route.params.outlet_code
        if (outlet_code != 'new') {
            this.loadOutlet(outlet_code)
        }
        
    },
    methods: {
        getBotols() {
            let dataMiscCodes = this.$store.state.misccode.objs
            this.botols = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                })
        },
        filterBotols() {
            if (this.selectedBotol.length === 0) {
                this.filteredBotols = this.botols
            } else {
                this.filteredBotols = this.botols.filter(item => this.selectedBotol.includes(item.code))
            }

            let firstBotol = this.filteredBotols.slice(0, 1)[0];
            this.filterBotol = firstBotol.code
        },
        generateDefaultTime() {
            this.defaultTimes = [];

            for (let i = 0; i < 24; i++) {
                
                this.defaultTimes.push({
                    id: i,
                    text: i > 9 ? `${i}:00` : `0${i}:00`
                });
            }
            for (let i = 0; i < 7; i++) {
                let obj = [];
                for (let j = 0; j < 24; j++) {
                    obj.push(0);
                }

                this.outlet.weekdays_hours_percent.push({
                    'min_stock': 0,
                    'max_stock': 0,
                    'min_stock2': 0,
                    'max_stock2': 0,
                    'times': obj
                });
            }
            
        },
        async getDataProducts() {
            let response = await this.$store.dispatch('variant/getObjs')
            if (response.data.status == 'success') {
                this.products = response.data.data;
            }
        },
        async loadOutlet(code) {
            try {
                this.isLoading = true

                const data = (await this.$store.dispatch('outlet/getObj', code))
                this.outlet = data
                this.selectedBotol = this.outlet.botols
                this.filterBotols();
                if (this.filterBotol) {
                    this.chooseBotol(this.filterBotol);
                }

                if (this.outlet.targets.length == 0) {
                    this.generateDefaultTargets()
                }

                if (this.outlet.menus.length == 0) {
                    this.generateDefaultMenus();
                } else {
                    this.getMenuBySize(this.filterBotol);
                }

                this.editedIndex = 1
            } catch (error) {
                console.log('Error loading data:', error)
            } finally {
                this.isLoading = false
            }
        },
        async chooseCategory() {
            const data = (await this.$store.dispatch('outletcategory/getObj', this.outlet.outlet_category_code))
            this.outlet.sales_targets = data.products;
            this.outlet.weekdays_hours_percent = data.weekdays_hours_percent
            this.outlet.targets = data.targets;

            this.selectedBotol = data.botols

            this.filterBotols()
        },
        async chooseBotol(value) {
            if (this.filteredSalesTargets.length == 0) {
                // let dataProduct = this.products.filter(p => p.size === value && p.is_active === true)
                let response = await this.$store.dispatch('outletcategory/getObjs');
                const responseData = response.data.data;
                const categoryItem = responseData.find((c) => c.code === this.outlet.outlet_category_code);

                if (categoryItem) {
                    const filterProducts = categoryItem.products.filter((product) => product.size === this.filterBotol 
                        && product.is_active == true);

                    this.outlet.sales_targets = filterProducts.map((item) => {
                        return {
                            code: item.code,
                            name: item.name,
                            size: item.size,
                            target_sun: item.target_sun,
                            target_mon: item.target_mon,
                            target_tue: item.target_tue,
                            target_wed: item.target_wed,
                            target_thu: item.target_thu,
                            target_fri: item.target_fri,
                            target_sat: item.target_sat,
                        }
                    });
                }
                
                // this.outlet.sales_targets = dataProduct.map(item => {
                //     return {
                //         code: item.code,
                //         name: item.name,
                //         size: item.size,
                //         target_mon: 0,
                //         target_tue: 0,
                //         target_wed: 0,
                //         target_thu: 0,
                //         target_fri: 0,
                //         target_sat: 0,
                //         target_sun: 0,
                //     }
                // })
            } else {
                const existTarget = this.outlet.targets.find((target) => target.size === value);
                if (!existTarget) {
                    console.log('tidak ada target, ambil dari kategori');
                    const currentCategory = this.categories.find((category) => category.code === this.outlet.outlet_category_code);
                    if (currentCategory) {
                        const selectedTarget = currentCategory.targets.find((target) => target.size === value);
                        if (selectedTarget) {
                            this.outlet.targets.push(selectedTarget);
                        }
                    }
                }
            }

            // get menu
            this.fetchMenuOptions(value);
            this.selectedMenuValues = this.getMenuBySize(value);
        },
        async fetchMenuOptions(value) {
            //menu
            this.selectedMenuValues = Array(7).fill(null);
            const response = await this.$store.dispatch('masterdatamenu/getObjsByVolume', value);
            this.menuOptions = response.data.data;
        },
        async handleMenuChange(selectedValue, columnIndex) {
            this.onProgress = true;
            const daysMap = ['target_sun', 'target_mon', 'target_tue', 'target_wed', 'target_thu', 'target_fri', 'target_sat'];
            const targetField = daysMap[columnIndex];
            if (!targetField) return;

            try {
                const response = await this.$store.dispatch('masterdatamenu/getObj', selectedValue);
                const details = response.details || [];
                this.outlet.sales_targets.filter(i => i.size == this.filterBotol)
                    .forEach(salesTarget => {
                        const matchedDetail = details.find(d => d.variant_code === salesTarget.code);

                        if (matchedDetail) {
                            this.$set(salesTarget, targetField, Number(matchedDetail.quantity));
                            this.$set(salesTarget, 'quantity', Number(matchedDetail.quantity));
                        } else {
                            this.$set(salesTarget, targetField, 0);
                        }
                    });

            } catch (error) {
                console.error('Error ambil detail menu:', error);
            }
            this.onProgress = false;
        },
        async saveOutlet() {
            await this.$refs.outletform.validate();

            if (!this.valid) return;

            this.onProgress = true;

            try {
                const result = await this.$store.dispatch('outlet/postObj', this.outlet)
                if (result.status == 200 || result.status == 201) {
                    // this.$router.go(-1)
                    this.$router.push(`/outlet`);
                    this.saved = true
                } else {
                    this.saveError = true
                }
            } catch (error) {
                console.error('Error save outlet:', error);
            } finally {
                this.onProgress = false;
            }
        },
        async updateOutlet() {
            await this.$refs.outletform.validate();

            if (!this.valid) return;

            this.onProgress = true;

            try {
                const result = await this.$store.dispatch('outlet/putObj', {payload: this.outlet, outlet_code: this.outlet.code})
                if (result.status == 200) {
                    // this.$router.go(-1)
                    // this.$router.push(`/outlet`);
                    this.saved = true
                } else {
                    this.saveError = true
                }
            } catch (error) {
                console.log('Error update outlet:', error);
            } finally {
                this.onProgress = false;
            }
        },
        async resetWeekdayTime() {
            if (this.outlet.outlet_category_code != '') {
                const data = (await this.$store.dispatch('outletcategory/getObj', this.outlet.outlet_category_code))
                
                this.outlet.weekdays_hours_percent = data.weekdays_hours_percent
            }

            this.closeReset();
        },
        async resetDataDefaultPPIC() {
            let response = await this.$store.dispatch('outletcategory/getObjs');
            const responseData = response.data.data;
            const categoryItem = responseData.find((c) => c.code === this.outlet.outlet_category_code);

            if (categoryItem) {
                const filterProducts = categoryItem.products.filter((product) => product.size === this.filterBotol)

                this.outlet.sales_targets = filterProducts.map((item) => {
                    return {
                        code: item.code,
                        name: item.name,
                        size: item.size,
                        target_sun: item.target_sun,
                        target_mon: item.target_mon,
                        target_tue: item.target_tue,
                        target_wed: item.target_wed,
                        target_thu: item.target_thu,
                        target_fri: item.target_fri,
                        target_sat: item.target_sat,
                    }
                });
                // this.outlet.sales_targets = this.outlet.sales_targets.map((item) => {
                //     const findProduct = filterProducts.find((product) => product.code === item.code);

                //     if (findProduct) {
                //         return {
                //             ...item,
                //             target_sun: findProduct.target_sun,
                //             target_mon: findProduct.target_mon,
                //             target_tue: findProduct.target_tue,
                //             target_wed: findProduct.target_wed,
                //             target_thu: findProduct.target_thu,
                //             target_fri: findProduct.target_fri,
                //             target_sat: findProduct.target_sat,
                //         }
                //     }

                //     return item;
                // });
            }
            
            this.closeResetPPIC();
        },
        generateDefaultTargets() {
            this.outlet.targets = [];
            let dataBotol = this.filteredBotols;

            this.outlet.targets = [];
            dataBotol.forEach((item) => {
                this.outlet.targets.push({
                    'size': item.code,
                    'days': [0,0,0,0,0,0,0]
                });
            });
        },
        generateDefaultMenus() {
            let dataBotol = this.filteredBotols;

            this.outlet.menus = [];
            dataBotol.forEach((item) => {
                const emptyMenus = Array(7).fill('');
                this.outlet.menus.push({
                    'size': item.code,
                    'menus': emptyMenus,
                });
            });
        },
        changeDeliverySchedule() {
            this.generateStatusBotol();
            this.checkDeliveryScheduleIsExist();
            this.checkDeliverySchedules2();
        },
        changeInnerCity() {
            if (!this.outlet.is_inner_city) {
                this.generateStatusBotol();
            }
        },
        generateStatusBotol() {
            const totalDeliverySchedule = this.outlet.delivery_schedules.length;

            for (let i = 1; i <= 7; i++) {
                let value = 0;

                for (let j = 0; j < totalDeliverySchedule; j++) {
                    const day = this.outlet.delivery_schedules[j];

                    if (i === day) {
                        const indexNextItem = (j + 1) % totalDeliverySchedule;
                        const itemNext = this.outlet.delivery_schedules[indexNextItem];
                        value = this.calculateDay(i,itemNext);
                    }
                }

                this.$set(this.outlet.status_botol, i - 1, value);

            }
        },
        calculateDay(firstDay, secondDay) {
            let difference = secondDay - firstDay;
            if (difference <= 0) difference += 7;
            return difference;
        },
        closeReset () {
            this.dialogResetToDefault = false
        },
       
        resetToDefault() {
            this.dialogResetToDefault = true
        },
        resetConfirm () {
            this.resetWeekdayTime();
        },
        resetToDefaultPPIC() {
            this.dialogResetToDefaultPPIC = true;
        },
        closeResetPPIC() {
            this.dialogResetToDefaultPPIC = false;
        },
        resetConfirmPPIC() {
            this.resetDataDefaultPPIC();
        },
        checkDeliveryScheduleIsExist() {
            const scheduleMap = {
                1: { coordinator: 'coordinator_sun', line: 'line_sun', name: 'coordinator_sun_name' },
                2: { coordinator: 'coordinator_mon', line: 'line_mon', name: 'coordinator_mon_name' },
                3: { coordinator: 'coordinator_tue', line: 'line_tue', name: 'coordinator_tue_name' },
                4: { coordinator: 'coordinator_wed', line: 'line_wed', name: 'coordinator_wed_name' },
                5: { coordinator: 'coordinator_thu', line: 'line_thu', name: 'coordinator_thu_name' },
                6: { coordinator: 'coordinator_fri', line: 'line_fri', name: 'coordinator_fri_name' },
                7: { coordinator: 'coordinator_sat', line: 'line_sat', name: 'coordinator_sat_name' },
            };

            this.outlet.delivery_schedules.sort((a, b) => a - b);

            for (let i = 1; i <= 7; i++) {
                const isExist = this.outlet.delivery_schedules.includes(i);
                if (!isExist) {
                    const schedule = scheduleMap[i];
                    if (schedule) {
                        this.outlet[schedule.coordinator] = null;
                        if (schedule.line) this.outlet[schedule.line] = null;
                        if (schedule.name) this.outlet[schedule.name] = null;
                    }
                }
            }
        },
        generateDefaultSalesTargets() {
            if (this.filteredSalesTargets.length == 0) {
                let dataProduct = this.products.filter(p => p.size === this.filterBotol)
                this.outlet.sales_targets = dataProduct.map(item => {
                    return {
                        code: item.code,
                        name: item.name,
                        size: item.size,
                        target_mon: 0,
                        target_tue: 0,
                        target_wed: 0,
                        target_thu: 0,
                        target_fri: 0,
                        target_sat: 0,
                        target_sun: 0,
                    }
                })
            } else {
                const existTarget = this.outlet.targets.find((target) => target.size === this.filterBotol);
                if (!existTarget) {
                    console.log('tidak ada target, ambil dari kategori');
                    const currentCategory = this.categories.find((category) => category.code === this.outlet.outlet_category_code);
                    if (currentCategory) {
                        const selectedTarget = currentCategory.targets.find((target) => target.size === this.filterBotol);
                        if (selectedTarget) {
                            this.outlet.targets.push(selectedTarget);
                        }
                    }
                }
            }
        },
        checkDeliverySchedules2() {
            for (let i = 0; i < this.outlet.delivery_schedules.length; i++) {
                if (!this.outlet.delivery_schedules2[i]) {
                    this.outlet.delivery_schedules2[i] = 0;
                }
                if (!this.outlet.arrive_schedules[i]) {
                    this.outlet.arrive_schedules[i] = 0;
                }
            }
        },
        backToOutlet() {
            this.$router.push(`/outlet`);
        },
        getMenuBySize(size) {
            let found = this.outlet.menus.find(i => i.size === size);
            if (!found) {
                this.outlet.menus.push({
                    size: size,
                    menus: Array(7).fill(''),
                });
                found = this.outlet.menus.find(i => i.size === size);
            }            
            return found.menus;
        }
    },
}
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}
#outletform .col {
    padding: 5px!important;
}
.centered-input >>> input {
    text-align: center
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>